import { type GetHookResponse, type WithEnabled } from '../hooks'
import { teamListKey } from '../keys'
import { useTantalimQuery } from '../query'
import { useTeamCache } from './cache'
import { type TeamListInput, type TeamListSuccess, type TeamData } from '@terros/common'

export type UseTeamProps = WithEnabled & TeamListInput

export function useTeams({ enabled, ...input }: UseTeamProps = {}): GetHookResponse<TeamData[]> {
  const cache = useTeamCache()
  return useTantalimQuery<TeamListInput, TeamListSuccess, TeamData[]>({
    url: '/team/list',
    queryKey: teamListKey(input),
    input,
    convertResponse: (responseData) => {
      responseData.teams.sort((a, b) => a.name.localeCompare(b.name))
      cache.setTinyTeams(responseData.teams)
      return responseData.teams
    },
    options: {
      enabled,
    },
  })
}
